import React, { useEffect, useState } from 'react'
import securedcheckout from "src/assets/images/secured-checkout-icon.svg";
import { Tooltip } from 'src/component/Global/Tooltip';
import CheckoutInvoiceAddress from './CheckoutInvoiceAddress';
import Constants from "../../helper/Constants";
import System from "../../helper/system";
import Helper from "../../helper/Helper";
import { profileStore } from "../../hooks/profile";
import CheckOut from '@system/config/checkout';
import useReduxState from 'src/hooks/useReduxState';
import { useOrderStore } from 'src/hooks/order';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import { useCartStore } from 'src/hooks/cart';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import AxiosIndicatorRunTimeLoader from 'src/component/Global/AxiosIndicatorRunTimeLoader';
import yellowAlert from "src/assets/images/yellow-alert.png";
import { __remove, __set } from "../../store/axios_indicator";
import HelperAnalyticsEvent from 'src/support/HelperAnalyticsEvent';
import RoleAndPermission from 'src/helper/RoleAndPermission';
import Cookies from "js-cookie";

const CheckoutPaymentMethod = () => {
    const [__check] = useAxiosIndicatorCheck();
    const { translation: t, storageName: { CART_CHECKOUT_PLACE_ORDER } } = System;
    const {
        countryCodes,
        poNumberPattern,
        addressAsiaCheckoutPattern,
        addressType,
        paymentError,
        siteUser: { WEB, CORE },
        paymentType: { CreditCard, AvnetCredit, WireTransfer, DefaultPaymentTerm, Alipay, ChinaUnionPay },
        checkOutSteps: { PAYMENT_STEP },
        speedBoats: { apacAbbr, japanAbbr },
        checkoutApiSteps: { Step3 },
        UserRoles: { ZA, ZC },
        paymentMode: { ALIPAY, CHINAPAY, CC, Eximbay },
        houseNumPattern
    } = Constants;
    const { storageName: { PAYMENT_ERROR, ORDER_FEEDBACK }, avUserInfoData: { currentUser, speedBoatAbbr } } = System;

    const [paymentMethod, setPaymentMethod] = useState('');
    const [sameAsShipTo, setSameAsShipTo] = useState(true);
    const [invoiceDetail, setInvoiceDetail] = useState({});
    const [detailValidation, setDetailValidation] = useState({});
    const [orderValidation, setOrderValidation] = useState({});
    const [tnc, setTnc] = useState(false);
    const [stateList, setStateList] = useState([]);
    const [showAlert, setShowAlert] = useState(false)
    const [isSubmitted, setIsSubmitted] = useState(false)
    const [payDollarData, setPayDollarData] = useState({})

    const [{ countryList, billing_addresses, credit_line_user, profile_account_information, profile_user_information }, { get_country_list, get_state_list }] = profileStore();
    const [{ place_order_item_list }, { }, { place_your_order }] = useOrderStore()
    const [{ WEB_ORDER_ID, CART_PRODUCTS, CART_DATA }, { }, { }] = useCartStore();
    const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();

    const [checkoutInfo, setCheckoutInfo] = useReduxState({}, 'setCheckoutInfo')
    const shippingAddressInfo = checkoutInfo?.shippingAddressInfo || {}
    const shippingMethodInfo = checkoutInfo?.shippingMethodInfo || {}
    const paymentMethodInfo = checkoutInfo.paymentMethodInfo || {}

    const [checkOutStepStatus] = useReduxState('', 'setCheckoutStepStatus')
    const [checkoutData] = useReduxState({}, 'setCheckoutData')

    const termsAndConditionLink = System.getCurrentRegionWithType(japanAbbr) ?
        "https://www.avnet.com/wcm/connect/31bb22f6-b816-4139-8386-9e7c44ec5324/Terms+and+Conditions+of+Sale+-+Japanese.pdf?MOD=AJPERES&CONVERT_TO=url&CACHEID=ROOTWORKSPACE.Z18_NA5A1I41L0ICD0ABNDMDDG0000-31bb22f6-b816-4139-8386-9e7c44ec5324-mb-d1Im?MOD=AJPERES&CONVERT_TO=url&CACHEID=ROOTWORKSPACE.Z18_NA5A1I41L0ICD0ABNDMDDG0000-31bb22f6-b816-4139-8386-9e7c44ec5324-mb-d1Im"
        : "https://www.avnet.com/wps/portal/apac/about-avnet/terms-and-conditions-of-sale/"

    const isWebUser = currentUser === WEB
    const isOnlySoftwareParts = CART_PRODUCTS && !Object.values(CART_PRODUCTS).some(f => f.SoftwareDownloadFlag === false);
    const contactZA = profile_account_information?.contacts?.find(contact => contact?.title === ZA);
    const contactZC = profile_account_information?.contacts?.find(contact => contact?.title === ZC);
    const isCoreUser = System.avUserInfoData.currentUser === CORE

    const isPlaceOrderPermission = RoleAndPermission.checkActivePermission(RoleAndPermission.checkoutPermission.place_order)

    useEffect(() => {
        if (payDollarData?.secureHash) {
            let button = document.getElementById("orderSubmit");
            button.click();
        }
    }, [payDollarData.secureHash])

    const onValueChange = (field, value) => {
        let updatedValue = value;
        if (field === 'stateCode' && stateList.length !== 0 && invoiceDetail?.countryCode) {
            updatedValue = stateList.find((state) => state.stateCode === value)?.stateCode;
        }
        const newInvoiceDetail = { ...invoiceDetail, [field]: updatedValue };
        setInvoiceDetail(newInvoiceDetail);
        if (isSubmitted) {
            onValidateData(newInvoiceDetail);
        }
    }

    useEffect(() => {
        async function fetchHere() {
            await get_country_list();
        }
        if (countryList?.length <= 0 && paymentMethod === CreditCard) {
            fetchHere()
        }
    }, [paymentMethod])

    useEffect(() => {
        if (System.getCurrentRegionWithType(apacAbbr, CORE)) {
            setPaymentMethod(AvnetCredit)
        } else if (System.getCurrentRegionWithType(japanAbbr) && credit_line_user) {
            setPaymentMethod(DefaultPaymentTerm)
        }
    }, [checkOutStepStatus])

    const onValidateData = (invoiceDetail) => {
        let validationModal = {};
        if (!Helper.valueIsNotNull(invoiceDetail.addressLineOne) || ((invoiceDetail.addressLineOne)?.trim() && !addressAsiaCheckoutPattern.test(invoiceDetail.addressLineOne))) {
            validationModal.addressLineOne = t('validAddressRequired');
        }
        if ((invoiceDetail.addressLineTwo)?.trim() && !addressAsiaCheckoutPattern.test(invoiceDetail.addressLineTwo)) {
            validationModal.addressLineTwo = t('validAddressRequired');
        }
        if (!Helper.valueIsNotNull(invoiceDetail.cityName) || ((invoiceDetail.cityName)?.trim() && !addressAsiaCheckoutPattern.test(invoiceDetail.cityName))) {
            validationModal.cityName = t('validCityRequired');
        }
        if (!Helper.valueIsNotNull(invoiceDetail.postalCode) || ((invoiceDetail.postalCode)?.trim() && !System.validatePostalCode(invoiceDetail.postalCode, invoiceDetail?.countryCode))) {
            validationModal.postalCode = t('validZipCodeRequired');
        }
        const isCountryCode = (Helper.valueIsNotNull(invoiceDetail.countryCode));
        if (!isCountryCode) {
            validationModal.countryCode = t('validCountryRequired');
        }
        if ((isCountryCode && countryCodes.includes(invoiceDetail.countryCode) && !Helper.valueIsNotNull(invoiceDetail.stateCode)) || (!countryCodes.includes(invoiceDetail.countryCode) &&  invoiceDetail?.stateCode?.length > 60)) {
              validationModal.stateCode = t('validStateProvinceRequired');
            }
        if ((Helper.valueIsNotNull(invoiceDetail.houseNum)) && (!Helper.validateRegex(invoiceDetail.houseNum, houseNumPattern))) {
            validationModal.houseNumber = t('validHouseNumber');
        }
        if ((invoiceDetail.addressLineThree)?.trim() && !addressAsiaCheckoutPattern.test(invoiceDetail.addressLineThree)) {
            validationModal.addressLineThree = t('validAddressRequired');
        }
        if ((Helper.valueIsNotNull(invoiceDetail.district)) && ((!Helper.validateRegex(invoiceDetail.district, houseNumPattern)))) {
            validationModal.district = t('validDistrict');
        }
        setDetailValidation(validationModal);
        return Object.keys(validationModal).length === 0;
    };

    useEffect(() => {
        setInvoiceDetail(shippingAddressInfo?.address || {})
        setCheckoutInfo({
            ...checkoutInfo, paymentMethodInfo: { ...paymentMethodInfo }
        })
    }, [JSON.stringify(shippingAddressInfo)]);


    const onPlaceOrder = async (event) => {
        const { id, ...shippingMethodWithoutId } = shippingMethodInfo;
        const checkoutPayload = { ...checkoutData, currencyType: System.getRegionCurrency() };
        const refNumber = Helper.UUID()

        setIsSubmitted(true)
        const isValid = onValidate()
        const coreUserAddress = billing_addresses?.find(ele => profile_account_information?.customerNo === ele?.id)
        const params = {
            "billToId": billing_addresses?.length ? (paymentMethodInfo?.invoiceAddressType === addressType?.SHIP_TO ? shippingAddressInfo?.id : ((isCoreUser && coreUserAddress?.address?.addressType === Constants.PRIMARY && coreUserAddress) ? coreUserAddress?.id : billing_addresses[0]?.id)) : (shippingAddressInfo?.id || null),
            "shipToId": shippingAddressInfo && shippingAddressInfo.id ? shippingAddressInfo.id : '',
            "attn": place_order_item_list?.attn,
            "telephoneNumber": place_order_item_list?.telephoneNumber,
            "SoftwareDownloadEmail": place_order_item_list?.softwareDownloadEmail,
            "carrier": isOnlySoftwareParts ? null : shippingMethodWithoutId,
            "pecEmail": place_order_item_list?.pecEmail,
            "purchaseOrderNumber": paymentMethodInfo?.purchaseOrderNumber || "",
            "sapQuoteNumber": place_order_item_list?.sapQuoteNumber,
            "orderBlock": false,
            "creditRisk": false,
            "isOrderPlaced": (paymentMethod === Alipay || paymentMethod === ChinaUnionPay || paymentMethod === CreditCard) ? false : true,
            "paymentMethod": paymentMethod,
            "orderEstimationReq": checkoutPayload,
            "speedboat": speedBoatAbbr,
            "orderStep": Step3,
            "shippingPreference": shippingAddressInfo.shippingPreference,
            "eximbayId": System.getCurrentRegionWithType(japanAbbr) ? refNumber : null
        }

        if (isValid && paymentMethod === CreditCard) {
            const creditCardReq = {
                houseNum: invoiceDetail.houseNum,
                houseNumSuppl: invoiceDetail.houseNumSuppl,
                cardHolderAddress1: invoiceDetail.addressLineOne,
                cardHolderAddress2: invoiceDetail.addressLineTwo,
                cardHolderAddress3: invoiceDetail.addressLineThree,
                cardHolderCity: invoiceDetail.cityName,
                district: invoiceDetail.district,
                cardHolderState: invoiceDetail.stateCode,
                cardHolderZip: invoiceDetail.postalCode,
                cardHolderCountry: invoiceDetail.countryCode,
            }
            params.creditCardReq = creditCardReq
            placeOrder(params, refNumber)
        } else if (isValid && (paymentMethod === AvnetCredit || paymentMethod === WireTransfer || paymentMethod === DefaultPaymentTerm || paymentMethod === Alipay || paymentMethod === ChinaUnionPay)) {
            __set("PLACE_ORDER_API_CALL");
            placeOrder(params)
        }
    }

    const placeOrder = async (params, refNumber = null) => {

        if (!isPlaceOrderPermission) {
            system_alert_indicator({
                name: 'internalUserPermission',
                message: t('internalUserPermission'),
                type: "danger",
                isDisplay: false,
                isDisplayIcon: true
            })
            __remove("PLACE_ORDER_API_CALL");
            return;
        }

        const response = await place_your_order(params)

        if (response?.paymentError) {
            __remove("PLACE_ORDER_API_CALL");
            localStorage.setItem(PAYMENT_ERROR, response?.paymentError);
            system_alert_indicator({
                name: 'placeOrderError',
                message: response?.paymentError,
                type: "danger",
                isDisplay: false,
                isDisplayIcon: true
            })
            const url = new URL(window.location.href);
            if (!url.searchParams.has(paymentError)) {
                url.searchParams.set(paymentError, 'true');
            }
            window.location.replace(url.toString());

        } else if (response?.webOrderNumber) {
            localStorage.setItem(ORDER_FEEDBACK, true);
            sessionStorage.setItem(response?.webOrderNumber, true)
            checkoutEvent();
            if (paymentMethod === AvnetCredit || paymentMethod === WireTransfer || paymentMethod === DefaultPaymentTerm) {
                let newUrl = `${CheckOut.getCheckOutStatusRouteURL()}?orderId=${response?.webOrderNumber}&currentCurrency=${System.getRegionCurrency()}`;
                Cookies.remove(System.getCartCount())
                window.location.href = newUrl
            } else {
                Cookies.remove(System.getCartCount())
                let paymentGatewayData = {
                    merchantId: speedBoatAbbr === apacAbbr ? process.env.REACT_APP_PAYMENT_APAC_MERCHANTID : process.env.REACT_APP_PAYMENT_JAPAN_MERCHANTID,
                    orderRef: speedBoatAbbr === apacAbbr ? WEB_ORDER_ID : refNumber,
                    currCode: speedBoatAbbr === apacAbbr ? '840' : '392',
                    amount: checkoutData?.orderTotal?.toFixed(2),
                    payType: 'N',
                    lang: speedBoatAbbr === apacAbbr ? 'E' : 'J',
                    secretKey: speedBoatAbbr === apacAbbr ? process.env.REACT_APP_PAYMENT_APAC_SECCRETKEY : process.env.REACT_APP_PAYMENT_JAPAN_SECCRETKEY,
                    payMethod: paymentMethod === Alipay ? ALIPAY : paymentMethod === ChinaUnionPay ? CHINAPAY : (speedBoatAbbr === apacAbbr ? CC : Eximbay),
                    customerEmail: speedBoatAbbr === japanAbbr ? profile_user_information?.emailAddress : null
                }

                const signingDataString = `${paymentGatewayData.merchantId}|${paymentGatewayData.orderRef}|${paymentGatewayData.currCode}|${paymentGatewayData.amount}|${paymentGatewayData.payType}|${paymentGatewayData.secretKey}`;

                // Function to generate SHA-1 hash
                async function generateSHA1Hash(data) {
                    const encoder = new TextEncoder();
                    const dataBuffer = encoder.encode(data);
                    const hashBuffer = await crypto.subtle.digest('SHA-1', dataBuffer);
                    const hashArray = Array.from(new Uint8Array(hashBuffer));
                    return hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('');
                }

                (async () => {
                    const sha1Hash = await generateSHA1Hash(signingDataString);

                    setPayDollarData({
                        ...paymentGatewayData, secureHash: sha1Hash
                    })
                })();
                checkoutEvent();
            }
        } else if (response?.errorMessage) {
            __remove("PLACE_ORDER_API_CALL");
            system_alert_indicator({
                name: 'placeOrderError',
                message: response?.errorMessage,
                type: "danger",
                isDisplay: true,
                isDisplayIcon: false
            })
        } else {
            __remove("PLACE_ORDER_API_CALL");
            system_alert_indicator({
                name: 'placeOrderError',
                message: t('orderSubmissionFailedPleaseTryAgainLater'),
                type: "danger",
                isDisplay: false,
                isDisplayIcon: true
            })
        }
    }

    const onValidate = () => {
        let showAlert = false;
        if (Helper.valueIsNotNull(paymentMethodInfo?.purchaseOrderNumber) && !Helper.validateRegex(paymentMethodInfo?.purchaseOrderNumber, poNumberPattern)) {
            orderValidation.purchaseOrderNumber = t('aValidPurchaseOrderNumberIsRequired');
        } else {
            delete orderValidation.purchaseOrderNumber;
        }

        if (!paymentMethod && !System.getCurrentRegionWithType(apacAbbr, CORE)) {
            showAlert = true
            orderValidation.paymentMethod = t('youMustSelectAPaymentMethod');
        } else {
            delete orderValidation.paymentMethod;
        }

        if (isWebUser) {
            if (!paymentMethodInfo?.invoiceAddressType) {
                showAlert = true
                delete orderValidation.paymentMethod;
                orderValidation.invoiceAddressType = t('pleaseSelectAnInvoiceAddress');
            } else {
                delete orderValidation.invoiceAddressType;
            }
        }

        if (System.getCurrentRegionWithType(apacAbbr, CORE)) {
            if (!paymentMethodInfo.purchaseOrderNumber) {
                orderValidation.purchaseOrderNumber = t('thePurchaseOrderNumberFieldCannotBeEmpty');
            }
        }

        if (paymentMethod === CreditCard) {
            onValidateData(invoiceDetail)
        }
        setShowAlert(showAlert)
        setOrderValidation({ ...orderValidation })

        return Object.keys(orderValidation).length === 0 && (paymentMethod === CreditCard ? onValidateData(invoiceDetail) : true)
    }

    const renderStateListOnCountryChange = async (value) => {
        setStateList(await get_state_list(value))
    }

    const checkoutEvent = () => {
        let cartProductArr = Object.keys(CART_DATA).map((x) => {
            return { ...CART_DATA[x], ERPSupplierCode: CART_PRODUCTS[x]?.ERPSupplierCode, qas: CART_DATA[x]?.quantity }
        });
        if (cartProductArr.length > 0) {
            HelperAnalyticsEvent.cartEvent({ productList: cartProductArr, eventName: 'checkoutStep3' })
            localStorage.setItem(CART_CHECKOUT_PLACE_ORDER, true);
        }
    }
    return (
        <div
            className={"shipping-address steps-inner mb-3 " + ((checkOutStepStatus === PAYMENT_STEP) ? 'active' : '')}>
            {__check(['VALIDATE_ORDER_API_CALL', 'VIEW_CART_API_CALL', 'SET_DEFAULT_SHIPPING_ADDRESS_API_CALL', 'CARRIER_OPTION_UPDATE', 'PLACE_ORDER_API_CALL']).status &&
                <AxiosIndicatorRunTimeLoader overlay={true} />}
            <div className="checkout-titles d-flex justify-content-between"><h2>3. {t('paymentMethod')}</h2></div>
            <div className='checkbox-steps-content'>
                {showAlert &&
                    <div className={'alert alert-danger'} role="alert">
                        <span><div>{orderValidation.invoiceAddressType}</div></span>
                        <span><div>{orderValidation.paymentMethod}</div></span>
                        {!isWebUser && !paymentMethod ? <img className="ms-auto" src={yellowAlert} /> : <button type="button" className="close" data-dismiss="alert" aria-label="Close"
                            onClick={() => setShowAlert(false)}>
                            <span aria-hidden="true">&times;</span>
                        </button>}
                    </div>
                }
                {isWebUser && <>
                    {paymentMethod === CreditCard &&
                        <div className='guaranteed-checkout'>
                            <img src={securedcheckout} className="me-2" alt='Guaranteed Secure Checkout' />
                            {t('guaranteedSecureCheckout')}
                        </div>}
                    <h3 className="mt-2 text-uppercase">{t('selectPaymentMethod')}:</h3>
                    <ul className="mx-0 px-0 mt-2">
                        {System.getCurrentRegionWithType(japanAbbr) && credit_line_user ?
                            <li>
                                <div className="form-check mb-1">
                                    <input className="form-check-input mt-1" type="radio" name="paymentMethod"
                                        id="payment3"
                                        value="option3"
                                        checked
                                        onChange={(e) => {
                                            setShowAlert(false);
                                            setPaymentMethod(DefaultPaymentTerm)
                                            delete orderValidation.purchaseOrderNumber;
                                            setOrderValidation({ ...orderValidation });
                                        }} />
                                    <label className="form-check-label" htmlFor="payment3">{t('defaultPaymentTerms')}</label>
                                </div>
                            </li> :
                            <>
                                <li>
                                    <div className="form-check mb-1">
                                        <input className="form-check-input mt-1" type="radio" name="paymentMethod"
                                            id="payment1"
                                            value="option1"
                                            onChange={(e) => {
                                                setShowAlert(false);
                                                setPaymentMethod(WireTransfer)
                                                delete orderValidation.purchaseOrderNumber;
                                                setOrderValidation({ ...orderValidation });
                                            }} />
                                        <label className="form-check-label" htmlFor="payment1">{System.getCurrentRegionWithType(japanAbbr) ? t('advancePayment') : t('wireTransfer')}</label>
                                    </div>
                                </li>
                                <li>
                                    <div className="form-check mb-1">
                                        <input className="form-check-input mt-1" type="radio" name="paymentMethod"
                                            id="payment2"
                                            value="option2"
                                            onChange={async (e) => {
                                                setShowAlert(false);
                                                setPaymentMethod(CreditCard)
                                                delete orderValidation.purchaseOrderNumber;
                                                setOrderValidation({ ...orderValidation })
                                            }} />
                                        <label className="form-check-label" htmlFor="payment2">{System.getCurrentRegionWithType(japanAbbr) ? t('creditDebitCard') : t('creditCard')}</label></div>
                                </li>
                                {System.getCurrentRegionWithType(apacAbbr) &&
                                    <>
                                        <li>
                                            <div className="form-check mb-1">
                                                <input className="form-check-input mt-1" type="radio" name="paymentMethod"
                                                    id="payment3"
                                                    value="option3"
                                                    onChange={async (e) => {
                                                        setShowAlert(false);
                                                        setPaymentMethod(Alipay)
                                                        delete orderValidation.purchaseOrderNumber;
                                                        setOrderValidation({ ...orderValidation })
                                                    }} />
                                                <label className="form-check-label" htmlFor="payment3">{t('alipay')}</label></div>
                                        </li>
                                        <li>
                                            <div className="form-check mb-1">
                                                <input className="form-check-input mt-1" type="radio" name="paymentMethod"
                                                    id="payment4"
                                                    value="option4"
                                                    onChange={async (e) => {
                                                        setShowAlert(false);
                                                        setPaymentMethod(ChinaUnionPay)
                                                        delete orderValidation.purchaseOrderNumber;
                                                        setOrderValidation({ ...orderValidation })
                                                    }} />
                                                <label className="form-check-label" htmlFor="payment4">{t('chinaUnionPay')}</label></div>
                                        </li>
                                    </>}
                            </>}
                        {System.getCurrentRegionWithType(japanAbbr) && !credit_line_user && <div className='credit-line-method mt-2 mb-2'>
                            <div className="shipping-additional-info step-complete-hide info-text">
                                <span>{t('japanPaymentText1')}</span><br />
                                <span>{t('japanPaymentText2')}</span>
                            </div>
                        </div>}
                    </ul>
                </>}
                {System.getCurrentRegionWithType(apacAbbr, CORE) &&
                    <div>
                        <h3 className="mt-0 mb-2 text-uppercase">{t('selectPaymentMethod')}:</h3>
                        <div className="info-text d-inline-flex mb-2">
                            <label className="mb-0" htmlFor="payment3">{t('creditLinePayment')}</label>
                        </div>
                        <p>{t('contactUsForOrderQuestions')} <span className="text-blue">{contactZC?.contactName || ''} {contactZA?.contactName ? <span className="text-black text-capitalize">{t('or')} <span className="text-blue">{contactZA?.contactName}.</span></span> : ''}</span></p>
                    </div>}
                {paymentMethod === CreditCard &&
                    <div className='creaditcard-method-container'>
                        <hr></hr>
                        <div className='row'>
                            <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 card-billing-address'>
                                <h3 className="mt-0 text-uppercase">{t("cardBillingAddress")}</h3>
                                <div className="form-check mb-1">
                                    <input className="form-check-input mt-1" type="checkbox" name="shipre"
                                        id="carshipre1" checked={sameAsShipTo} onChange={(e) => {
                                            setSameAsShipTo(e.target.checked);
                                            if (e.target.checked) {
                                                setIsSubmitted(false)
                                                setDetailValidation({})
                                                setInvoiceDetail(shippingAddressInfo.address)
                                            } else {
                                                setIsSubmitted(false)
                                                if (stateList.length === 0) {
                                                    renderStateListOnCountryChange(shippingAddressInfo.address.countryCode);
                                                }
                                                setInvoiceDetail({
                                                    addressLineOne: '',
                                                    addressLineTwo: '',
                                                    cityName: '',
                                                    countryCode: System.getCurrentRegionWithType(japanAbbr) ? shippingAddressInfo.address.countryCode : '',
                                                    stateCode: '',
                                                    postalCode: '',
                                                    district: '',
                                                    addressLineThree: '',
                                                    houseNum: '',
                                                })
                                            }
                                        }}
                                    />
                                    <label className="form-check-label" htmlFor="carshipre1">{t('useShippingAddressAsCreditCardAddress')}</label>
                                </div>
                                <div className='bs5 row'>
                                    {System.getCurrentRegionWithType(Constants.speedBoats.apacAbbr) &&
                                        <div className="col-12">
                                            <div className="form-group">
                                                <label htmlFor="houseNumber" className="d-block">{t('houseNumber')}</label>
                                                <input
                                                    type="text"
                                                    className={`form-control form-control-sm ${detailValidation.houseNumber ? "error" : ""} ${sameAsShipTo ? "readonly-field" : ""}`}
                                                    id="houseNumber"
                                                    placeholder={t('houseNumber')}
                                                    name="houseNumber"
                                                    maxLength={6}
                                                    value={invoiceDetail.houseNum || ''}
                                                    onChange={({ target: { value } }) => onValueChange("houseNum", value)}
                                                    readOnly={sameAsShipTo}
                                                />
                                                {detailValidation.houseNumber && <p className="error">{detailValidation.houseNumber}</p>}
                                            </div>
                                        </div>
                                    }
                                    <div className='col-12'>
                                        <div className='form-group'>
                                            <label className="form-label">{t('address')} 1*</label>
                                            <input type="text"
                                                className={`form-control form-control-sm ${detailValidation.addressLineOne ? "error" : ""} ${sameAsShipTo ? "readonly-field" : ""}`}
                                                placeholder={`${t('address')} 1`}
                                                maxLength={35}
                                                name="addressLineOne"
                                                value={invoiceDetail.addressLineOne || ''}
                                                onChange={(event) => {
                                                    onValueChange("addressLineOne", event.target.value);
                                                }}
                                                readOnly={sameAsShipTo}
                                            />
                                            {detailValidation.addressLineOne &&
                                                <p className="error">{detailValidation.addressLineOne}</p>}
                                        </div>
                                    </div>
                                    <div className='col-12'>
                                        <div className='form-group'>
                                            <label className="form-label">{t('address')} 2</label>
                                            <input type="text"
                                                className={`form-control form-control-sm ${detailValidation.addressLineTwo ? "error" : ""} ${sameAsShipTo ? "readonly-field" : ""}`}
                                                placeholder={`${t('address')} 2`}
                                                name="addressLineTwo"
                                                maxLength={35}
                                                value={invoiceDetail.addressLineTwo || ''}
                                                onChange={(event) => {
                                                    onValueChange("addressLineTwo", event.target.value);
                                                }}
                                                readOnly={sameAsShipTo} />
                                            {detailValidation.addressLineTwo &&
                                                <p className="error">{detailValidation.addressLineTwo}</p>}
                                        </div>
                                    </div>
                                    {System.getCurrentRegionWithType(Constants.speedBoats.apacAbbr) &&
                                        <div className="col-12">
                                            <div className="form-group">
                                                <label className="d-block">{t('address3')}</label>
                                                <input
                                                    type="text"
                                                    className={`form-control form-control-sm ${detailValidation.addressLineThree ? "error" : ""} ${sameAsShipTo ? "readonly-field" : ""}`}
                                                    placeholder={t('address3')}
                                                    name="addressLineThree"
                                                    maxLength={35}
                                                    value={invoiceDetail.addressLineThree || ''}
                                                    onChange={({ target: { value } }) => onValueChange("addressLineThree", value)}
                                                    readOnly={sameAsShipTo}
                                                />
                                                {detailValidation.addressLineThree && <p className="error">{detailValidation.addressLineThree}</p>}
                                            </div>
                                        </div>
                                    }
                                    <div className='col-12'>
                                        <div className='form-group'>
                                            <label className="form-label">{t('city')}*</label>
                                            <input type="text"
                                                className={`form-control form-control-sm ${detailValidation.cityName ? "error" : ""} ${sameAsShipTo ? "readonly-field" : ""}`}
                                                placeholder={t('city')} name="cityName"
                                                value={invoiceDetail.cityName || ''}
                                                maxLength={35}
                                                onChange={(event) => {
                                                    onValueChange("cityName", event.target.value);
                                                }}
                                                readOnly={sameAsShipTo} />
                                            {detailValidation.cityName &&
                                                <p className="error">{detailValidation.cityName}</p>}
                                        </div>
                                    </div>
                                    {System.getCurrentRegionWithType(Constants.speedBoats.apacAbbr) &&
                                        <div className="col-12">
                                            <div className="form-group">
                                                <label htmlFor="district" className="d-block">{t('district')}</label>
                                                <input
                                                    type="text"
                                                    className={`form-control form-control-sm ${detailValidation.district ? "error" : ""} ${sameAsShipTo ? "readonly-field" : ""}`}
                                                    id="district"
                                                    placeholder={t('district')}
                                                    name="district"
                                                    maxLength={35}
                                                    value={invoiceDetail.district || ''}
                                                    onChange={({ target: { value } }) => onValueChange("district", value)}
                                                    readOnly={sameAsShipTo}
                                                />
                                                {detailValidation.district && <p className="error">{detailValidation.district}</p>}
                                            </div>
                                        </div>
                                    }
                                    <div className='col-12'>
                                        <div className='form-group'>
                                            <label
                                                className="form-label">{t('country')}*</label>
                                            <select
                                                className={`form-control form-control-sm ${detailValidation.countryCode ? "error" : ""} ${sameAsShipTo ? "readonly-field" : ""}`}
                                                name="countryCode"
                                                value={invoiceDetail.countryCode}
                                                onChange={({ target: { value } }) => {
                                                    onValueChange("countryCode", value);
                                                    setStateList([]);
                                                    setInvoiceDetail({
                                                        ...invoiceDetail, countryCode: value, stateCode: ''
                                                    });
                                                    if (countryCodes.includes(value)) {
                                                        renderStateListOnCountryChange(value)
                                                    }
                                                }}
                                                disabled={System.getCurrentRegionWithType(japanAbbr) ? true : sameAsShipTo}
                                            >
                                                <option value="">{t('pleaseSelect')}</option>
                                                {countryList?.map((v, i) => (<option key={v.countryId}
                                                    value={v.countryCode}>{v.countryName}</option>))}
                                            </select>
                                            {detailValidation.countryCode &&
                                                <p className="error">{detailValidation.countryCode}</p>}
                                        </div>
                                    </div>
                                    <div className='col-6'>
                                        <div className='form-group'>
                                            <label htmlFor="stateCode"
                                                className="d-block">{stateList.length !== 0 && invoiceDetail?.countryCode ? `${t('stateProvince')}*` : t('stateProvince')}</label>
                                            {(stateList.length !== 0 && invoiceDetail?.countryCode) ? <>
                                                <select
                                                    className={`form-control form-control-sm ${detailValidation.stateCode ? "error" : ""} ${sameAsShipTo ? "readonly-field" : ""}`}
                                                    name="stateCode"
                                                    value={stateList.length === 0 ? invoiceDetail.stateName || '' : invoiceDetail.stateCode || ''}
                                                    onChange={({ target: { value } }) => onValueChange("stateCode", value)}
                                                    disabled={sameAsShipTo}
                                                >
                                                    <option value="">
                                                        {sameAsShipTo && invoiceDetail?.stateName ? invoiceDetail.stateName : t('select')}
                                                    </option>
                                                    {stateList.map((v, i) => (<option key={v.stateId}
                                                        value={v.stateCode}>{v.stateName}</option>))}
                                                </select>
                                                {detailValidation.stateCode &&
                                                    <p className="error">{detailValidation.stateCode}</p>}
                                            </> :
                                            <> <input
                                                type="text"
                                                className={`form-control form-control-sm ${""} ${sameAsShipTo ? "readonly-field" : ""}`}
                                                id="stateCode"
                                                placeholder={t('select')}
                                                name="stateCode"
                                                maxLength={60}
                                                value={stateList.length === 0 ? invoiceDetail.stateName || '' : invoiceDetail.stateCode || ''}
                                                onChange={({ target: { value } }) => onValueChange("stateCode", value)}
                                                readOnly={sameAsShipTo}
                                            />
                                            {detailValidation.stateCode &&
                                                    <p className="error">{detailValidation.stateCode}</p>}
                                            </>}
                                        </div>
                                    </div>
                                    <div className='col-6'>
                                        <div className='form-group'>
                                            <label className="form-label">{t('zipPostalCode')}*</label>
                                            <input type="text"
                                                className={`form-control form-control-sm ${detailValidation.postalCode ? "error" : ""} ${sameAsShipTo ? "readonly-field" : ""}`}
                                                placeholder={t('zipPostalCode')}
                                                name="postalCode"
                                                maxLength={System.getZipCodeLength(invoiceDetail.countryCode)}
                                                value={invoiceDetail.postalCode || ''}
                                                onChange={(event) => {
                                                    onValueChange("postalCode", event.target.value);
                                                }}
                                                readOnly={sameAsShipTo} />
                                            {detailValidation.postalCode &&
                                                <p className="error">{detailValidation.postalCode}</p>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}
                <hr className='p-0'></hr>
                <CheckoutInvoiceAddress orderValidation={orderValidation} setOrderValidation={setOrderValidation}
                    setShowAlert={setShowAlert} />

                <div className='credit-line-method mt-2 mb-2'>
                    <div className="shipping-additional-info step-complete-hide info-text"><p>{t('checkoutPaymentMethodText')}</p></div>
                </div>
                <div className='text-right mt-3 mb-3'>
                    <div className="form-check mb-2">
                        <input className="form-check-input float-none me-1 border-black" type="checkbox" id="tc"
                            name="tnc"
                            onChange={(event) => {
                                setTnc(event.target.checked);
                            }}
                            value={tnc}
                        />
                        <label className="form-check-label" htmlFor="tc">
                            {!System.getCurrentRegionWithType(japanAbbr) &&
                                <span className="p-l-05">*{t('iHaveReadAndAgreeToThe')}</span>
                            }
                            {System.getCurrentRegionWithType(japanAbbr) ?
                                <><a className="text-blue2 p-l-05 text-lowercase"
                                    href={termsAndConditionLink} target="_blank" rel="noreferrer">*{t('iHaveReadAndAgreeToThe')}</a>{t('and')}<a href="javascript:void(0);"
                                        onClick={() => System.popup('SoATermsPopup')}>{t('termsAndCondition')}</a>{t('soaTerms')}
                                </> : <>
                                    <a className="text-blue2 p-l-05 text-lowercase"
                                        href={termsAndConditionLink}
                                        target="_blank" rel="noreferrer">{t('termsAndCondition')}</a> {t('and')} <a href="javascript:void(0);" onClick={() => System.popup('SoATermsPopup')}>{t('soaTerms')}</a>
                                </>
                            }
                        </label>
                    </div>
                    {!tnc ? <Tooltip
                        position={'bottom center'}
                        opener={() => (
                            <span className="w150 ms-auto bs5 d-flex">
                                <button type="button" disabled={true} onClick={onPlaceOrder}
                                    className="bs5 btn btn-primary btn-sm mt-auto ms-auto w150">
                                    {t('placeOrder')}
                                </button>
                            </span>
                        )}
                        content={() => (
                            <p>{t('pleaseSelectTheCheckboxToPlaceTheOrder')}</p>
                        )}
                    /> : <button type="button" onClick={onPlaceOrder}
                        className="bs5 btn btn-primary btn-sm mt-auto d-block ms-auto w150">
                        {t('placeOrder')}
                    </button>
                    }
                </div>
                <form className="d-none" name="payFormCcard" method="post" action={process.env.REACT_APP_PAYMENT_URL}>
                    <input type="hidden" name="merchantId" value={payDollarData.merchantId} />
                    <input type="hidden" name="customer_email" value={payDollarData.customerEmail}></input>
                    <input type="hidden" name="amount" value={payDollarData.amount} />
                    <input type="hidden" name="orderRef" value={payDollarData.orderRef} />
                    <input type="hidden" name="currCode" value={payDollarData.currCode} />
                    <input type="hidden" name="mpsMode" value="NIL" />
                    <input type="hidden" name="successUrl" value={`${System.getPreviousPageUrl()}/shop/order-confirmation?orderId=${WEB_ORDER_ID}`} />
                    <input type="hidden" name="failUrl" value={`${System.getPreviousPageUrl()}/shop/check-out`} />
                    <input type="hidden" name="cancelUrl" value={`${System.getPreviousPageUrl()}/shop/check-out`} />
                    <input type="hidden" name="payType" value={payDollarData.payType} />
                    <input type="hidden" name="lang" value={speedBoatAbbr === apacAbbr ? 'E' : 'J'} />
                    <input type="hidden" name="payMethod" value={payDollarData.payMethod} />
                    <input type="hidden" name="secureHash" value={payDollarData.secureHash} />
                    <input type="submit" name="submit" id="orderSubmit" />
                </form>
            </div>
        </div>);
}

export default CheckoutPaymentMethod;